import { jwtDecode } from "jwt-decode";
import {
	getOrStartRefresh,
	isAuthInvalidated,
} from "../auth/refreshCoordinator";

export const ensureValidToken = async (dispatch, getState, token) => {
	if (!token) {
		return undefined;
	}
	if (isTokenExpired(token)) {
		const newToken = await getOrStartRefresh(dispatch);

		// Auth may have been invalidated between coordinator resolve and the
		// WS open. Refuse to open a socket with a freshly minted token after
		// manual logout / terminal invalidation.
		if (isAuthInvalidated()) {
			throw new Error("Auth invalidated during refresh");
		}

		if (!newToken) {
			throw new Error("Token refresh failed");
		}

		token = newToken;
	}

	return token;
};

const isTokenExpired = (token) => {
	try {
		const decoded = jwtDecode(token);
		return decoded.exp * 1000 < Date.now();
	} catch {
		return true;
	}
};
